import React from 'react';

import { LayoutPage } from 'components/layouts';
import HomeHero from './components/home-hero';
import HomeIntro from './components/home-intro';
import HomeBenefits from './components/home-benefits';
import HomeRoutes from './components/home-routes';
import WorkerHero from './components/worker-hero';
import WorkerIntro from './components/worker-intro';
import WorkerWhy from './components/worker-why';
import WorkerBenefits from './components/worker-benefits';
import WorkerControl from './components/worker-control';
import WorkerWarning from './components/worker-warning';
import EmployerHero from './components/employer-hero';
import EmployerBenefits from './components/employer-benefits';
import EmployerCostEffective from './components/employer-cost-effective';
import EmployerExamples from './components/employer-examples';
import EmployerMyLearning from './components/employer-my-learning';
import EmployerControl from './components/employer-control';
import EmployerHow from './components/employer-how';
import SignUp from './components/sign-up';
import './style.css';

const Home = () => {
  return (
    <LayoutPage className="home-page" userType="">
      <HomeIntro />
      <HomeHero />
      <HomeBenefits />
      <HomeRoutes />
    </LayoutPage>
  );
};

const HomeWorker = () => {
  return (
    <LayoutPage className="home-page" userType="isWorker">
      <WorkerHero />
      <WorkerControl />
      <WorkerIntro />
      <WorkerWhy />
      <SignUp userType="isWorker" />
      <WorkerBenefits />
      <SignUp userType="isWorker" />
    </LayoutPage>
  );
};

const HomeWorkerWarning = () => {
  return (
    <LayoutPage className="home-page" userType="isWorker">
      <WorkerWarning />
    </LayoutPage>
  );
};

const HomeEmployer = () => {
  return (
    <LayoutPage className="home-page" userType="isEmployer">
      <EmployerHero />
      <EmployerControl />
      <EmployerHow />
      <SignUp userType="isEmployer" />
      <EmployerBenefits />
      <EmployerMyLearning />
      <EmployerCostEffective />
      <EmployerExamples />
      <SignUp userType="isEmployer" />
    </LayoutPage>
  );
};

export { Home, HomeWorker, HomeWorkerWarning, HomeEmployer };
